export default {
  companyMeetingsMetadata: {},
};
